import styled from 'styled-components/macro';
import { colorCoreBackground1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const FlexWrapperStyled = styled(FlexWrapper) `
  background-color: ${colorCoreBackground1000};
`;
export const RegularTextLevel3Styled = styled(RegularTextLevel3) `
  padding: ${INDENT.xs} ${INDENT.sm};
`;
